import { useState, useEffect } from "react";

export default function useMockLoading(dependencies = [], duration = 600) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, duration);

    return () => clearTimeout(timer);
  }, dependencies);

  return isLoading;
}
